import { render, staticRenderFns } from "./CompetitionGuideDownload.vue?vue&type=template&id=5874ae1e&scoped=true"
import script from "./CompetitionGuideDownload.vue?vue&type=script&lang=js"
export * from "./CompetitionGuideDownload.vue?vue&type=script&lang=js"
import style0 from "./CompetitionGuideDownload.vue?vue&type=style&index=0&id=5874ae1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5874ae1e",
  null
  
)

export default component.exports